import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { loadFromLocalStorage } from '@utils/storage';

export const RiderRegistrationLayout = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const role = loadFromLocalStorage('selectedRole');
        if (!role) {
            navigate('/unauthorized', { replace: true });
            return;
        }

        const parsed = typeof role === 'string' ? JSON.parse(role) : role;
        if (parsed?.name !== 'Rider') {
            navigate('/unauthorized', { replace: true });
        }
    }, [navigate]);

    return <Outlet />;
};
